import React from "react";
import {
  Button,
  ButtonVariants,
  ButtonSizes,
  ButtonColors,
  ButtonTypes
} from "@certa/catalyst/components/Button";
import { Plus } from "@certa/icons/components/Plus";
import { Trashcan } from "@certa/icons/components/Trashcan";
import { useIntl } from "react-intl";

type AppendQueryProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const AppendQuery: React.FC<AppendQueryProps> = ({
  onClick,
  disabled = false
}) => {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: "filters.appendQuery",
    defaultMessage: "Append Query"
  });

  return (
    <Button
      variant={ButtonVariants.LINK}
      size={ButtonSizes.SMALL}
      leftIcon={<Plus size={16} />}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

type AppendGroupQueryProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const AppendGroupQuery: React.FC<AppendGroupQueryProps> = ({
  onClick,
  disabled = false
}) => {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: "filters.appendGroupQuery",
    defaultMessage: "Append Group Query"
  });

  return (
    <Button
      variant={ButtonVariants.LINK}
      size={ButtonSizes.SMALL}
      leftIcon={<Plus size={16} />}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

type RemoveIconButtonProps = {
  onClick: () => void;
  ariaLabel: string;
  disabled?: boolean;
};

export const RemoveIconButton: React.FC<RemoveIconButtonProps> = ({
  onClick,
  ariaLabel,
  disabled = false
}) => {
  return (
    <div style={{ flexShrink: 0 }}>
      <Button
        size={ButtonSizes.SMALL}
        type={ButtonTypes.ICON}
        rightIcon={<Trashcan />}
        color={ButtonColors.RED}
        onClick={onClick}
        aria-label={ariaLabel}
        disabled={disabled}
      />
    </div>
  );
};
